import React from 'react';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import { COLOR } from '@src/styles/color';
import {
  StyledOverlay,
  StyledBackdrop,
  StyledIndicator,
  StyledText,
} from './index.style';

const AILoadingOverlay = ({ text, blurAmount = '3px' }) => (
  <StyledOverlay>
    <StyledBackdrop blurAmount={blurAmount} />
    <StyledIndicator>
      <AutoAwesomeRoundedIcon sx={{ fontSize: 24, color: COLOR.blueV2 }} />
      <StyledText>{text}</StyledText>
    </StyledIndicator>
  </StyledOverlay>
);

export default AILoadingOverlay;
